import gql from 'graphql-tag';

export const FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION = gql`
  fragment BlogPostBuilderOutlineSection on BlogPostBuilderOutlineSection {
    id
    headline
    content
    paragraphs # can be removed after all sections would be converted to HTML
    order
    keywordsUsage
    manualKeywords
    instructions
    lastPlagiarismCheckResult # currently not used for outlines, leaving here for future use
    generationLength
    textStatus
    subtopic
    details
  }
`;

export const FRAGMENT_PROJECT_BLOG_CONTENT = gql`
  fragment BlogPostBuilderContent on BlogPostBuilderContent {
    id
    title
    titleScore
    introParagraph
    introManualKeywords
    introKeywordsUsage
    introInstructions
    introGenerationLength
    introTextStatus
    lastPlagiarismCheckResult {
      potentialCopiedSentences {
        url
        title
        snippet
        percentMatched
      }
      overallSimilarityPercent
      checksUsed
      lastCheckTime
    }
    outlineSections {
      ...BlogPostBuilderOutlineSection
    }
    generationInfo
  }
  ${FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION}
`;

export const FRAGMENT_BLOG_POST_BUILDER_DRAFT = gql`
  fragment BlogPostBuilderDraft on BlogPostBuilderDraft {
    id
    projectId
    draftId
    status
    name
    generationInfo
    language
    complianceStatus
    complianceProgressPercentage
  }
`;
